export default {
  id: 'reports',
  title: 'Izvještaji',
  icon: 'mdi-chart-bar',
  show: true,
  order: 11,
  children: [
    {
      id: 'reports-recapitulation',
      title: 'Recapitulacija prometa',
      icon: 'mdi-file-document',
      content: () => `
        <h2 id="recapitulation">Recapitulacija prometa</h2>
        <p>
          Recapitulacija prometa je osnovni financijski izvještaj koji prikazuje
          ukupan promet po načinu plaćanja, PDV stopama i vremenskom razdoblju.
        </p>

        <h3 class="mt-4">Pristup izvještaju</h3>
        <ol>
          <li>Idite na <strong>"Izvještaji" → "Recapitulacija prometa"</strong></li>
          <li>Postavite filtere (datum, blagajna, prodajno mjesto)</li>
          <li>Kliknite <strong>"Prikaži izvještaj"</strong></li>
        </ol>

        <h3 class="mt-4">Filtri</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Filter</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Datum od - do *</strong></td>
              <td>Odaberite razdoblje (danas, ovaj tjedan, mjesec, prilagođeno)</td>
            </tr>
            <tr>
              <td><strong>Prodajno mjesto</strong></td>
              <td>Filtriraj po određenom prodajnom mjestu (ili sva mjesta)</td>
            </tr>
            <tr>
              <td><strong>Blagajna</strong></td>
              <td>Filtriraj po određenoj blagajni (ili sve blagajne)</td>
            </tr>
            <tr>
              <td><strong>Operator</strong></td>
              <td>Filtriraj po korisniku (opciono)</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Što se prikazuje u izvještaju?</h3>

        <h4 class="mt-3">1. Promet po načinu plaćanja</h4>
        <table class="info-table">
          <thead>
            <tr>
              <th>Način plaćanja</th>
              <th>Broj računa</th>
              <th>Iznos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Gotovina</td>
              <td>125</td>
              <td>15.450,00 €</td>
            </tr>
            <tr>
              <td>Kartica</td>
              <td>89</td>
              <td>12.300,00 €</td>
            </tr>
            <tr>
              <td>Transakcijski račun</td>
              <td>12</td>
              <td>8.900,00 €</td>
            </tr>
            <tr>
              <td><strong>UKUPNO</strong></td>
              <td><strong>226</strong></td>
              <td><strong>36.650,00 €</strong></td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">2. Promet po PDV stopama</h4>
        <table class="info-table">
          <thead>
            <tr>
              <th>PDV stopa</th>
              <th>Osnovica</th>
              <th>PDV</th>
              <th>Ukupno</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>25%</td>
              <td>20.000,00 €</td>
              <td>5.000,00 €</td>
              <td>25.000,00 €</td>
            </tr>
            <tr>
              <td>13%</td>
              <td>8.000,00 €</td>
              <td>1.040,00 €</td>
              <td>9.040,00 €</td>
            </tr>
            <tr>
              <td>5%</td>
              <td>2.500,00 €</td>
              <td>125,00 €</td>
              <td>2.625,00 €</td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">3. Dnevni promet (po danima)</h4>
        <p>Grafički prikaz prometa po danima u odabranom razdoblju.</p>

        <h4 class="mt-3">4. Promet po blagajnama</h4>
        <p>Ako imate više blagajna, prikazuje se razdioba prometa po svakoj blagajni.</p>

        <h4 class="mt-3">5. Top artikli</h4>
        <p>Lista najprodavanijih artikala u odabranom razdoblju.</p>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Izvještaj uključuje samo fiskalizirane račune. Stornirani računi su prikazani odvojeno.
          </div>
        </div>

        <h3 class="mt-4">Izvoz izvještaja</h3>
        <p>Izvještaj možete izvesti u sljedećim formatima:</p>
        <ul>
          <li><strong>PDF</strong> - Za ispis ili slanje računovođi</li>
          <li><strong>Excel (.xlsx)</strong> - Za daljnju analizu</li>
          <li><strong>CSV</strong> - Za import u druge sustave</li>
        </ul>

        <h3 class="mt-4">Usporedba razdoblja</h3>
        <p>Možete usporediti dva razdoblja:</p>
        <ol>
          <li>Uključite opciju <strong>"Usporedi s razdobljem"</strong></li>
          <li>Odaberite drugo razdoblje za usporedbu</li>
          <li>Izvještaj prikazuje razlike i postotke rasta/pada</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Koristite ovaj izvještaj za dnevne, tjedne i mjesečne analize prodaje i planiranje nabave.
          </div>
        </div>

        <h2 id="tips" class="mt-6">Česta pitanja</h2>
        <ul>
          <li><strong>Zašto se iznosi ne poklapaju?</strong> - Provjerite jesu li svi računi fiskalizirani</li>
          <li><strong>Mogu li vidjeti promet po satima?</strong> - Da, u "Detaljnoj analizi prometa"</li>
          <li><strong>Kako izvesti za računovođu?</strong> - Izvezite PDF ili Excel za cijeli mjesec</li>
        </ul>
      `
    },
    {
      id: 'reports-buyers',
      title: 'Recapitulacija kupaca',
      icon: 'mdi-account-group',
      content: () => `
        <h2 id="buyers-report">Recapitulacija kupaca</h2>
        <p>
          Izvještaj kupaca prikazuje prodaju po klijentima (Associates),
          omogućavajući analizu najprofitabilnijih klijenata i praćenje dugovanja.
        </p>

        <h3 class="mt-4">Pristup izvještaju</h3>
        <ol>
          <li>Idite na <strong>"Izvještaji" → "Recapitulacija kupaca"</strong></li>
          <li>Postavite filtere (datum, klijent)</li>
          <li>Kliknite <strong>"Prikaži izvještaj"</strong></li>
        </ol>

        <h3 class="mt-4">Filtri</h3>
        <ul>
          <li><strong>Datum od - do *</strong> - Odaberite razdoblje</li>
          <li><strong>Klijent</strong> - Svi klijenti ili određeni klijent</li>
          <li><strong>Tip klijenta</strong> - Fizičke osobe (R1) ili Pravne osobe (R2)</li>
          <li><strong>Status plaćanja</strong> - Plaćeno, Neplaćeno (dugovanja)</li>
        </ul>

        <h3 class="mt-4">Što se prikazuje u izvještaju?</h3>

        <h4 class="mt-3">1. Tablica kupaca</h4>
        <table class="info-table">
          <thead>
            <tr>
              <th>Kupac</th>
              <th>OIB</th>
              <th>Broj računa</th>
              <th>Ukupan iznos</th>
              <th>Plaćeno</th>
              <th>Duguje</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Hotel Adriatic d.o.o.</td>
              <td>12345678901</td>
              <td>45</td>
              <td>125.450,00 €</td>
              <td>100.000,00 €</td>
              <td>25.450,00 €</td>
            </tr>
            <tr>
              <td>Restoran Dalmacija</td>
              <td>98765432109</td>
              <td>32</td>
              <td>89.200,00 €</td>
              <td>89.200,00 €</td>
              <td>0,00 €</td>
            </tr>
            <tr>
              <td>Ivan Horvat (fizička)</td>
              <td>-</td>
              <td>12</td>
              <td>3.450,00 €</td>
              <td>3.450,00 €</td>
              <td>0,00 €</td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">2. Top 10 kupaca</h4>
        <p>Grafički prikaz 10 kupaca sa najvećim prometom.</p>

        <h4 class="mt-3">3. Analiza po tipovima klijenata</h4>
        <ul>
          <li><strong>Fizičke osobe (R1)</strong> - Ukupan promet i broj računa</li>
          <li><strong>Pravne osobe (R2)</strong> - Ukupan promet i broj računa</li>
        </ul>

        <h4 class="mt-3">4. Status plaćanja</h4>
        <ul>
          <li><strong>Plaćeno u cijelosti</strong> - Broj klijenata i iznos</li>
          <li><strong>Djelomično plaćeno</strong> - Broj klijenata i preostali dug</li>
          <li><strong>Neplaćeno</strong> - Broj klijenata i ukupan dug</li>
        </ul>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Status plaćanja je dostupan samo za račune izdane na transakcijski račun (računi na rate). Gotovina i kartica se smatraju odmah plaćenima.
          </div>
        </div>

        <h3 class="mt-4">Detalji po kupcu</h3>
        <p>Kliknite na kupca u tablici za detaljan pregled:</p>
        <ul>
          <li>Lista svih računa</li>
          <li>Povijest plaćanja</li>
          <li>Top kupljeni artikli</li>
          <li>Prosječna vrijednost računa</li>
        </ul>

        <h3 class="mt-4">Izvoz izvještaja</h3>
        <ul>
          <li><strong>Excel (.xlsx)</strong> - Za daljnju analizu</li>
          <li><strong>PDF</strong> - Za slanje klijentima ili računovođi</li>
          <li><strong>CSV</strong> - Za import u ERP sustave</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Dugovanja:</strong> Redovno provjeravajte izvještaj dugovanja i kontaktirajte klijente s neplaćenim računima.
          </div>
        </div>

        <h3 class="mt-4">Slanje opomena</h3>
        <p>Za klijente s dugom možete poslati opomenu:</p>
        <ol>
          <li>Odaberite klijenta iz tablice</li>
          <li>Kliknite <strong>"Pošalji opomenu"</strong></li>
          <li>Sustav automatski generira email sa detaljima dugovanja</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Koristite ovaj izvještaj za praćenje najvažnijih klijenata i planiranje marketing aktivnosti prema njima.
          </div>
        </div>

        <h2 id="tips" class="mt-6">Česta pitanja</h2>
        <ul>
          <li><strong>Zašto nemam podatke o dugovima?</strong> - Status plaćanja se prati samo za račune na rate (transakcijski račun)</li>
          <li><strong>Kako označiti račun kao plaćen?</strong> - U detaljima računa kliknite "Označi kao plaćeno"</li>
          <li><strong>Mogu li vidjeti povijest kupnje?</strong> - Da, kliknite na kupca za detaljan pregled svih računa</li>
        </ul>
      `
    },
    {
      id: 'reports-tax',
      title: 'Porezni izvještaj (Tax Report)',
      icon: 'mdi-file-percent',
      content: () => `
        <h2 id="tax-report">Porezni izvještaj</h2>
        <p>
          Porezni izvještaj (Tax Report) prikazuje detaljnu analizu PDV-a (poreza na dodanu vrijednost)
          po stopama, potreban za prijavu PDV-a Poreznoj upravi. Izvještaj je ključan za pravilno
          vođenje poslovnih knjiga i redovito podnošenje poreznih prijava.
        </p>

        <h3 class="mt-4">Što sadrži porezni izvještaj?</h3>

        <p>Izvještaj prikazuje:</p>
        <ul>
          <li><strong>Ukupan promet po PDV stopama</strong> (25%, 13%, 5%, 0%)</li>
          <li><strong>Osnovicu</strong> - Iznos bez PDV-a</li>
          <li><strong>Iznos PDV-a</strong> - Obračunani porez</li>
          <li><strong>Ukupno s PDV-om</strong> - Konačni iznos s porezom</li>
          <li><strong>Storniran promet</strong> - Poništeni računi</li>
          <li><strong>Broj računa</strong> - Količina transakcija po stopi</li>
        </ul>

        <h3 class="mt-4">Pristup poreznom izvještaju</h3>

        <ol>
          <li>Idite na <strong>"Izvještaji" → "Porezni izvještaj"</strong></li>
          <li>Odaberite <strong>period</strong> (datum od - do)</li>
          <li>Odaberite <strong>prodajno mjesto</strong> (ili sve)</li>
          <li>Kliknite <strong>"Generiraj izvještaj"</strong></li>
        </ol>

        <h3 class="mt-4">Struktura izvještaja</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>PDV stopa</th>
              <th>Osnovica (bez PDV-a)</th>
              <th>PDV iznos</th>
              <th>Ukupno (s PDV-om)</th>
              <th>Broj računa</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>25%</strong></td>
              <td>80,000.00 EUR</td>
              <td>20,000.00 EUR</td>
              <td>100,000.00 EUR</td>
              <td>450</td>
            </tr>
            <tr>
              <td><strong>13%</strong></td>
              <td>17,699.12 EUR</td>
              <td>2,300.88 EUR</td>
              <td>20,000.00 EUR</td>
              <td>120</td>
            </tr>
            <tr>
              <td><strong>5%</strong></td>
              <td>9,523.81 EUR</td>
              <td>476.19 EUR</td>
              <td>10,000.00 EUR</td>
              <td>35</td>
            </tr>
            <tr>
              <td><strong>0%</strong></td>
              <td>5,000.00 EUR</td>
              <td>0.00 EUR</td>
              <td>5,000.00 EUR</td>
              <td>18</td>
            </tr>
            <tr style="font-weight: bold; background-color: rgba(57, 137, 201, 0.1);">
              <td><strong>UKUPNO</strong></td>
              <td>112,222.93 EUR</td>
              <td>22,777.07 EUR</td>
              <td>135,000.00 EUR</td>
              <td>623</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">PDV stope u Hrvatskoj</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Stopa</th>
              <th>Primjena</th>
              <th>Primjeri</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>25%</strong></td>
              <td>Opća (standardna) stopa</td>
              <td>Većina robe i usluga</td>
            </tr>
            <tr>
              <td><strong>13%</strong></td>
              <td>Snižena stopa</td>
              <td>Hrana, voda, lijekovi, knjige, hoteli</td>
            </tr>
            <tr>
              <td><strong>5%</strong></td>
              <td>Super snižena stopa</td>
              <td>Dječja hrana, medicinski proizvodi</td>
            </tr>
            <tr>
              <td><strong>0%</strong></td>
              <td>Oslobođeno PDV-a</td>
              <td>Izvoz, određene usluge</td>
            </tr>
          </tbody>
        </table>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> PDV stopa se definira na razini artikla.
            Prilikom kreiranja artikla obavezno je odabrati ispravnu PDV stopu prema zakonu.
          </div>
        </div>

        <h3 class="mt-4">Stornirani računi</h3>

        <p>
          Izvještaj prikazuje i stornirane (poništene) račune koji utječu na PDV obračun:
        </p>

        <ul>
          <li><strong>Storno iznos</strong> - Ukupan iznos poništenih računa</li>
          <li><strong>Storno PDV</strong> - PDV od storniranih računa</li>
          <li><strong>Broj storna</strong> - Količina poništenih računa</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Stornirani računi se <strong>oduzimaju</strong> od ukupnog prometa.
            Konačna osnovica za PDV prijavu je: Promet - Stornirani promet.
          </div>
        </div>

        <h3 class="mt-4">Periodi izvještavanja</h3>

        <p>Porezni izvještaj se najčešće kreira za sljedeće periode:</p>

        <h4 class="mt-3">1. Mjesečna prijava</h4>
        <p>Za obveznikePDV-a s prometom većim od 7.5 milijuna kuna godišnje:</p>
        <ul>
          <li>Generirajte izvještaj za cijeli mjesec (npr. 01.01. - 31.01.)</li>
          <li>Prijavite PDV do 20. u sljedećem mjesecu</li>
        </ul>

        <h4 class="mt-3">2. Tromjesečna prijava</h4>
        <p>Za obveznikePDV-a s prometom manjim od 7.5 milijuna kuna godišnje:</p>
        <ul>
          <li>Q1: 01.01. - 31.03.</li>
          <li>Q2: 01.04. - 30.06.</li>
          <li>Q3: 01.07. - 30.09.</li>
          <li>Q4: 01.10. - 31.12.</li>
        </ul>

        <h4 class="mt-3">3. Godišnja prijava</h4>
        <p>Za paušaliste i manje obveznike:</p>
        <ul>
          <li>Generirajte izvještaj za cijelu godinu (01.01. - 31.12.)</li>
        </ul>

        <h3 class="mt-4">Export izvještaja</h3>

        <p>Porezni izvještaj možete izvesti u sljedećim formatima:</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Format</th>
              <th>Upotreba</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>PDF</strong></td>
              <td>Za ispis i arhiviranje</td>
            </tr>
            <tr>
              <td><strong>Excel (.xlsx)</strong></td>
              <td>Za daljnju obradu i analizu</td>
            </tr>
            <tr>
              <td><strong>CSV</strong></td>
              <td>Za import u računovodstveni softver</td>
            </tr>
            <tr>
              <td><strong>XML</strong></td>
              <td>Za elektronsko podnošenje prijave (ePorezna)</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Usporedba s prethodnim periodom</h3>

        <p>
          Izvještaj omogućava usporedbu s prethodnim periodom:
        </p>
        <ul>
          <li>Odaberite opciju <strong>"Prikaži usporedbu"</strong></li>
          <li>Sustav će prikazati promet iz istog perioda prošle godine ili prošlog mjeseca</li>
          <li>Možete vidjeti postotnu promjenu (+/- %)</li>
        </ul>

        <h3 class="mt-4">Provjera točnosti</h3>

        <p>Prije podnošenja prijave provjerite:</p>

        <ol>
          <li><strong>Svi računi su fisklaizirani</strong> - Provjerite da nema računa s greškom</li>
          <li><strong>PDV stope su ispravne</strong> - Pregledajte artikle s neobičnim stopama</li>
          <li><strong>Storno računi su evidentirati</strong> - Svi poništeni računi moraju biti evidentirani</li>
          <li><strong>Period je ispravan</strong> - Provjerite datume od-do</li>
          <li><strong>Usporedite s bankom</strong> - Ukupan promet treba odgovarati prilivima</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Kreirajte izvještaj nekoliko dana prije roka za podnošenje prijave.
            Tako imate vremena riješiti eventualne neslaganja ili greške.
          </div>
        </div>

        <h3 class="mt-4">Integracija s računovodstvom</h3>

        <p>
          Podatke iz poreznog izvještaja možete exportirati i učitati u računovodstveni softver:
        </p>
        <ol>
          <li>Exportajte izvještaj u Excel ili CSV formatu</li>
          <li>Učitajte datoteku u vaš računovodstveni program</li>
          <li>Sustav će automatski kreirati knjiženja</li>
        </ol>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Kada moram podnijeti PDV prijavu?</h4>
        <p>
          <strong>Mjesečni obveznici:</strong> Do 20. u sljedećem mjesecu<br>
          <strong>Tromjesečni obveznici:</strong> Do 20. u prvom mjesecu sljedećeg kvartala<br>
          <strong>Godišnji obveznici:</strong> Do 31. siječnja sljedeće godine
        </p>

        <h4 class="mt-3">Što ako pronađem grešku nakon podnošenja prijave?</h4>
        <p>
          Morate podnijeti ispravak prijave kroz sustav ePorezna.
          Priložite ispravan porezni izvještaj iz AI Kasa sustava.
        </p>

        <h4 class="mt-3">Mogu li vidjeti izvještaj za više prodajnih mjesta odjednom?</h4>
        <p>
          Da, u filteru odaberite "Sva prodajna mjesta" ili specifično odaberite više lokacija.
          Izvještaj će zbrojiti promet svih odabranih mjesta.
        </p>

        <h4 class="mt-3">Gdje mogu vidjeti detalje po pojedinačnim računima?</h4>
        <p>
          Kliknite na PDV stopu u izvještaju. Otvorit će se popis svih računa s tom stopom
          za odabrani period.
        </p>

        <h4 class="mt-3">Što ako imam nefiskalizirane račune?</h4>
        <p>
          Nefiskalizirani računi se NE uključuju u porezni izvještaj.
          Prvo morate fiskalizirati sve račune, pa onda generirati izvještaj.
        </p>
      `
    },
    {
      id: 'reports-pnp',
      title: 'PNP izvještaj',
      icon: 'mdi-file-chart',
      content: () => `
        <h2 id="pnp-report">PNP izvještaj</h2>
        <p>
          PNP izvještaj (Prodaja na malo) je obavezni izvještaj o prodaji fizičkim osobama
          koji se podnosi Poreznoj upravi. Izvještaj sadrži detaljne podatke o svim fiskalnim računima
          izdanima u određenom periodu.
        </p>

        <h3 class="mt-4">Što je PNP?</h3>

        <p>
          <strong>PNP (Prodaja na malo)</strong> je sustav evidencije maloprodajnih transakcija koji omogućava:
        </p>
        <ul>
          <li>Elektronsku razmjenu podataka s Poreznom upravom</li>
          <li>Praćenje svih fiskalnih računa u realnom vremenu</li>
          <li>Automatsku provjeru valjanosti računa</li>
          <li>Transparentnost u poslovanju</li>
        </ul>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> PNP izvještaj je obavezan za sve obveznike PDV-a koji
            vrše prodaju robe i usluga fizičkim osobama.
          </div>
        </div>

        <h3 class="mt-4">Pristup PNP izvještaju</h3>

        <ol>
          <li>Idite na <strong>"Izvještaji" → "PNP izvještaj"</strong></li>
          <li>Odaberite <strong>period</strong> (datum od - do)</li>
          <li>Odaberite <strong>prodajno mjesto</strong> ili "Sva mjesta"</li>
          <li>Kliknite <strong>"Generiraj izvještaj"</strong></li>
        </ol>

        <h3 class="mt-4">Sadržaj PNP izvještaja</h3>

        <p>Izvještaj sadrži sljedeće podatke za svaki račun:</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Podatak</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>JIR</strong></td>
              <td>Jedinstveni identifikator računa</td>
            </tr>
            <tr>
              <td><strong>ZKI</strong></td>
              <td>Zaštitni kod izdavatelja</td>
            </tr>
            <tr>
              <td><strong>Broj računa</strong></td>
              <td>Redni broj računa</td>
            </tr>
            <tr>
              <td><strong>Datum i vrijeme</strong></td>
              <td>Točan trenutak izdavanja računa</td>
            </tr>
            <tr>
              <td><strong>Iznos</strong></td>
              <td>Ukupan iznos računa</td>
            </tr>
            <tr>
              <td><strong>PDV po stopama</strong></td>
              <td>Iznos PDV-a po 25%, 13%, 5%, 0%</td>
            </tr>
            <tr>
              <td><strong>Način plaćanja</strong></td>
              <td>Gotovina, Kartica, Transakcijski račun</td>
            </tr>
            <tr>
              <td><strong>Oznaka naknadne dostave</strong></td>
              <td>Da/Ne (za offline fiskalizaciju)</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Primjer PNP izvještaja</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>JIR</th>
              <th>Broj računa</th>
              <th>Datum/Vrijeme</th>
              <th>Iznos</th>
              <th>PDV 25%</th>
              <th>PDV 13%</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>3b5e1f4a-9c2d...</td>
              <td>1-1-001</td>
              <td>15.01.2024 10:25</td>
              <td>125.00 EUR</td>
              <td>25.00</td>
              <td>0.00</td>
            </tr>
            <tr>
              <td>7a8d3c2f-4b1e...</td>
              <td>1-1-002</td>
              <td>15.01.2024 10:32</td>
              <td>85.50 EUR</td>
              <td>15.50</td>
              <td>2.10</td>
            </tr>
            <tr>
              <td>9c1f5e3a-2d7b...</td>
              <td>1-1-003</td>
              <td>15.01.2024 10:48</td>
              <td>220.00 EUR</td>
              <td>44.00</td>
              <td>0.00</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Format izvoza</h3>

        <p>PNP izvještaj možete izvesti u više formata:</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Format</th>
              <th>Opis</th>
              <th>Upotreba</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>XML</strong></td>
              <td>Strukturirana datoteka za upload</td>
              <td>Elektronsko podnošenje Poreznoj upravi</td>
            </tr>
            <tr>
              <td><strong>Excel (.xlsx)</strong></td>
              <td>Pregledna tablica</td>
              <td>Analiza i interna kontrola</td>
            </tr>
            <tr>
              <td><strong>CSV</strong></td>
              <td>Tekstualna datoteka</td>
              <td>Import u računovodstveni softver</td>
            </tr>
            <tr>
              <td><strong>PDF</strong></td>
              <td>Dokument za ispis</td>
              <td>Arhiviranje i dokumentacija</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Podnošenje PNP izvještaja</h3>

        <h4 class="mt-3">Korak po korak</h4>

        <ol>
          <li>Generirajte PNP izvještaj za odgovarajući period</li>
          <li>Exportajte u <strong>XML</strong> format</li>
          <li>Prijavite se na <strong>ePorezna</strong> portal</li>
          <li>Idite na <strong>"PNP" → "Podnošenje izvještaja"</strong></li>
          <li>Učitajte XML datoteku</li>
          <li>Provjerite podatke i potvrdite podnošenje</li>
          <li>Preuzmite potvrdu o primitku</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Podnošenje PNP izvještaja je automatski proces.
            AI Kasa sustav generira XML datoteku koja je 100% kompatibilna s ePorezna sustavom.
          </div>
        </div>

        <h3 class="mt-4">Rokovi podnošenja</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Period</th>
              <th>Rok</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Mjesečni izvještaj</strong></td>
              <td>Do 15. u sljedećem mjesecu</td>
            </tr>
            <tr>
              <td><strong>Tromjesečni izvještaj</strong></td>
              <td>Do 15. u prvom mjesecu sljedećeg kvartala</td>
            </tr>
          </tbody>
        </table>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> Kašnjenje s podnošenjem PNP izvještaja može rezultirati
            novčanim kaznama od Porezne uprave. Podnošenje na vrijeme je obavezno!
          </div>
        </div>

        <h3 class="mt-4">Provjera ispravnosti</h3>

        <p>Prije podnošenja provjerite:</p>

        <ul>
          <li><strong>Svi računi su fisklaizirani</strong> - JIR i ZKI moraju biti prisutni</li>
          <li><strong>Nema grešaka u fiskalizaciji</strong> - Računi s greškom nisu u izvještaju</li>
          <li><strong>Period je ispravan</strong> - Provjerite datume od-do</li>
          <li><strong>Brojevi računa su kontinuirani</strong> - Nema preskočenih brojeva</li>
          <li><strong>Iznosi se podudaraju</strong> - Usporedite s dnevnim izvještajima</li>
        </ul>

        <h3 class="mt-4">Offline fiskalizacija (Naknadno dostavljeni računi)</h3>

        <p>
          Ako je blagajna bila offline, računi se fiskaliziraju naknadno.
          Takvi računi su označeni s:
        </p>
        <ul>
          <li><strong>Oznaka naknadne dostave: DA</strong></li>
          <li>Prikazuju se odvojeno u izvještaju</li>
          <li>Moraju biti prijavljeni s posebnom napomenom</li>
        </ul>

        <h3 class="mt-4">Statistika izvještaja</h3>

        <p>Na vrhu izvještaja prikazana je sažeta statistika:</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Statistika</th>
              <th>Primjer vrijednosti</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Ukupno računa</strong></td>
              <td>1,250</td>
            </tr>
            <tr>
              <td><strong>Ukupan promet</strong></td>
              <td>156,780.50 EUR</td>
            </tr>
            <tr>
              <td><strong>Prosječan račun</strong></td>
              <td>125.42 EUR</td>
            </tr>
            <tr>
              <td><strong>Storno računi</strong></td>
              <td>18 (-2,340.00 EUR)</td>
            </tr>
            <tr>
              <td><strong>Naknadno dostavljeni</strong></td>
              <td>5 (850.00 EUR)</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Što ako pronađem grešku nakon podnošenja?</h4>
        <p>
          Kontaktirajte Poreznu upravu putem ePorezna sustava i podnijeti ispravku.
          Priložite ispravan XML izvještaj iz AI Kasa sustava.
        </p>

        <h4 class="mt-3">Mogu li vidjeti koje račune još nisam prijavio?</h4>
        <p>
          Da, u modulu "Računi" možete filtrirati po statusu "Neprijavljeni u PNP".
          To su računi koji još nisu bili uključeni ni u jedan PNP izvještaj.
        </p>

        <h4 class="mt-3">Kako provjeriti da je izvještaj prihvaćen?</h4>
        <p>
          Nakon podnošenja na ePorezna portalu primit ćete potvrdu o primitku.
          Pohranite tu potvrdu kao dokaz uspješnog podnošenja.
        </p>

        <h4 class="mt-3">Što ako imam više prodajnih mjesta?</h4>
        <p>
          Možete podnijeti jedan zajednički izvještaj za sva mjesta ili zasebne izvještaje.
          Odaberite opciju u filteru prilikom generiranja izvještaja.
        </p>

        <h4 class="mt-3">Koliko često moram podnositi PNP izvještaj?</h4>
        <p>
          <strong>Mjesečni obveznici:</strong> Svaki mjesec do 15. u sljedećem mjesecu<br>
          <strong>Tromjesečni obveznici:</strong> Svaki kvartal do 15. u prvom mjesecu sljedećeg kvartala
        </p>
      `
    },
    {
      id: 'reports-items',
      title: 'Izvještaj artikala',
      icon: 'mdi-package-variant',
      content: () => `
        <h2 id="items-report">Izvještaj artikala</h2>
        <p>
          Izvještaj artikala prikazuje detaljnu prodaju po pojedinačnim artiklima.
          Ovaj izvještaj omogućava analizu najprodavanijih proizvoda, praćenje zaliha
          i optimizaciju asortimana.
        </p>

        <h3 class="mt-4">Pristup izvještaju</h3>
        <ol>
          <li>Idite na <strong>"Izvještaji" → "Izvještaj artikala"</strong></li>
          <li>Odaberite period (datum od - do)</li>
          <li>Odaberite prodajno mjesto ili kategoriju (opcionalno)</li>
          <li>Kliknite <strong>"Generiraj"</strong></li>
        </ol>

        <h3 class="mt-4">Sadržaj izvještaja</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Artikl</th>
              <th>Količina</th>
              <th>Promet</th>
              <th>Prosječna cijena</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Kava espresso</td>
              <td>245 kom</td>
              <td>367.50 EUR</td>
              <td>1.50 EUR</td>
            </tr>
            <tr>
              <td>Cappuccino</td>
              <td>189 kom</td>
              <td>378.00 EUR</td>
              <td>2.00 EUR</td>
            </tr>
            <tr>
              <td>Coca Cola 0.33L</td>
              <td>156 kom</td>
              <td>390.00 EUR</td>
              <td>2.50 EUR</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Filtriranje</h3>
        <ul>
          <li><strong>Po kategoriji</strong> - Prikažite samo artikle iz određene kategorije</li>
          <li><strong>Po PDV stopi</strong> - Filtrirajte po stopi PDV-a</li>
          <li><strong>Top N artikala</strong> - Prikaži top 10, 20, 50 najprodavanijih</li>
          <li><strong>Sortiraj po</strong> - Količini, prometu, nazivu</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Koristite ovaj izvještaj za optimizaciju zaliha -
            artikli s velikom prodajom uvijek trebaju biti na stanju.
          </div>
        </div>

        <h3 class="mt-4">Export opcije</h3>
        <p>Izvjestaj možete izvesti u:</p>
        <ul>
          <li><strong>Excel</strong> - Za daljnju analizu</li>
          <li><strong>PDF</strong> - Za ispis</li>
          <li><strong>CSV</strong> - Za import u druge sustave</li>
        </ul>

        <h3 class="mt-4">Često postavljana pitanja</h3>
        <h4 class="mt-3">Mogu li vidjeti koje artikle ne prodajem?</h4>
        <p>Da, koristite filter "Nulta prodaja" da vidite artikle koji nisu prodani u odabranom periodu.</p>

        <h4 class="mt-3">Uključuje li izvještaj stornirane račune?</h4>
        <p>Ne, stornirani računi nisu uključeni u prodajni izvještaj artikala.</p>
      `
    },
    {
      id: 'reports-tips',
      title: 'Recapitulacija napojnica',
      icon: 'mdi-cash',
      content: () => `
        <h2 id="tips-report">Recapitulacija napojnica</h2>
        <p>
          Izvještaj o napojnicama prikazuje sve napojnice (tips) koje su zaprimljene kroz sustav.
          Ovaj izvještaj je važan za praćenje dodatnih prihoda i raspodjelu napojnica zaposlenicima.
        </p>

        <h3 class="mt-4">Pristup izvještaju</h3>
        <ol>
          <li>Idite na <strong>"Izvještaji" → "Recapitulacija napojnica"</strong></li>
          <li>Odaberite period</li>
          <li>Odaberite korisnika (opcionalno)</li>
          <li>Generirajte izvještaj</li>
        </ol>

        <h3 class="mt-4">Sadržaj izvještaja</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Korisnik</th>
              <th>Broj računa s napojnicom</th>
              <th>Ukupno napojnica</th>
              <th>Prosjek po računu</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Marko Marić</td>
              <td>45</td>
              <td>135.00 EUR</td>
              <td>3.00 EUR</td>
            </tr>
            <tr>
              <td>Ana Anić</td>
              <td>38</td>
              <td>118.50 EUR</td>
              <td>3.12 EUR</td>
            </tr>
          </tbody>
        </table>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Napojnice mogu biti unesene ručno ili automatski
            dodane preko POS terminala za kartično plaćanje.
          </div>
        </div>

        <h3 class="mt-4">Često postavljana pitanja</h3>
        <h4 class="mt-3">Kako se unosi napojnica?</h4>
        <p>Prilikom naplate računa, blagajnik može dodati napojnicu u polje "Napojnica" prije finalizacije.</p>
      `
    }
  ]
}
